import React from 'react';
import { Box, Typography, Button, colors } from '@mui/material';
import { Link } from 'react-router-dom';
import Logo from '../gwmlogo.png';
import '../Header.css'; // Reuse the same CSS file as the header for consistency

export default function Footer() {
  return (
    <Box
      className="header-container" // Reuse the header-container class for styling consistency
      sx={{
        backgroundColor: '#1a202c', // Professional dark background
        position: 'relative',
        bottom: 0,
        width: '100%',
        mt: 4, // Add some margin-top to separate from content
        // Override header-container flex behavior for footer
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' }, // Stack on mobile, row on desktop
        justifyContent: { xs: 'center', md: 'space-between' }, // Center on mobile, space-between on desktop
        alignItems: { xs: 'center', md: 'center' }, // Center on mobile, align with header on desktop
        gap: { xs: 2, md: 0 }, // Vertical gap on mobile, none on desktop
        textAlign: { xs: 'center', md: 'left' }, // Center on mobile, left on desktop
        padding: { xs: '10px 15px', md: '10px 20px' }, // Match header padding
        height: { xs: 'auto', md: '60px' }, // Auto height on mobile, fixed on desktop
        '& .header-logo': { // Target the logo specifically
          height: { xs: '30px', md: '40px' }, // Adjust logo size
          marginBottom: { xs: 1, md: 0 }, // Spacing below logo on mobile only
        },
      }}
    >
      <img src={Logo} alt="GasWorks Media Logo" className="header-logo" />
      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 2 }}>
        <Button
          variant="text"
          component={Link}
          to="/privacy-policy"
          sx={{
            color: colors.grey[50],
            textTransform: 'none',
            '&:hover': {
              backgroundColor: colors.grey[900],
            },
          }}
        >
          Privacy Policy
        </Button>
        <Button
          variant="text"
          component={Link}
          to="/terms-of-service"
          sx={{
            color: colors.grey[50],
            textTransform: 'none',
            '&:hover': {
              backgroundColor: colors.grey[900],
            },
          }}
        >
          Terms of Service
        </Button>
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: colors.grey[50],
          textAlign: 'center',
          mt: { xs: 2, md: 0 }, // Remove margin-top on desktop
          width: { xs: '100%', md: 'auto' }, // Full width on mobile, auto on desktop
        }}
      >
        © 2025 GasWorks Media LLC. All rights reserved.
      </Typography>
    </Box>
  );
}